
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header className={`fixed w-full z-[999] transition-all duration-300 ${scrolled ? 'shadow-md bg-white/95 dark:bg-benchr-950/95 backdrop-blur-sm' : 'bg-white dark:bg-benchr-950'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <div className="flex items-center">
            <a href="/" className="flex items-center gap-2">
              <img
                src="/lovable-uploads/5b3fc61d-09cc-4356-aca7-ef3a45266769.png"
                alt="Benchr.ai Logo"
                className="h-12 md:h-16 w-auto" 
              />
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
